import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { getActiveDay } from '../times/selectors';
import { ANY_BARBER } from '../constants';
import { getShopAdvanceBookDays } from '../shops/selectors';
import { getBarberAdvanceBookDays } from '../barbers/selectors';
import * as reservationSelectors from '../reservation/selectors';


const WithAdvanceBookDays = compose(
  withRouter,
  connect((state, ownProps) => {
    const anyBarber = ownProps.params.barberRoute === ANY_BARBER;
    const advanceBookDays = (() => {
      if (!ownProps.params.barberRoute) {
        return reservationSelectors.getBarberAdvanceBookDays(state);
      }
      if (anyBarber) {
        return getShopAdvanceBookDays(state, ownProps.params.shopRoute);
      }
      return getBarberAdvanceBookDays(state, ownProps.params.barberRoute);
    })();
    return {
      activeDay: getActiveDay(state),
      advanceBookDays,
    };
  }),
);

export default WithAdvanceBookDays;



// WEBPACK FOOTER //
// ./src/app/hoc/WithAdvanceBookDays.js